export default __webpack_public_path__ + "static/media/4.48ce55b5.png";